import React from "react";
import ConfirmModal from "components/ConfirmModal";

const DeleteModal = (props) => {
  const { onDelete, title, isOpen, toogle } = props;

  const onConfirm = (e) => {
    if (onDelete) {
      onDelete(e)
    }
  }

  return (
    <>
      <ConfirmModal
        toggle={toogle}
        isOpen={isOpen}
        title={title}
        onConfirm={onConfirm}
        primaryBtn="Eliminar"
      >
        {props.children}
      </ConfirmModal>
    </>
  );

}

export default DeleteModal;